import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'tallymark-1', 'Tallymark1', [["path",{"d":"M12 5l0 14","key":"svg-0"}]]);